<script>
  import { cdnUrls } from "../data/cdnUrls";
  import { t } from "../stores/translations";
</script>

<section>
  <img src={cdnUrls.images.header} alt="Woman lying on top of a bed" />

  <div class="container">
    <h1>{$t("header.title")}</h1>

    <p>{@html $t("header.body")}</p>
  </div>
</section>

<style lang="scss">
  @import "src/lib/styles/variables.scss";
  @import "src/lib/styles/mixins.scss";

  section {
    background-color: $color-background;
    position: relative;

    & > img {
      width: 100%;
    }

    & > .container {
      box-shadow: 0px 4px 4px rgba(235, 235, 235, 0.25);
      background-color: $color-white;
      border-radius: 4px;
      padding: 1rem 1.5rem;
      margin: 0 1rem -1.5rem 1rem;
      translate: 0 -4rem;

      & > h1 {
        font-family: "Roboto Slab";
        color: $color-text;
        font-size: $font-size-extra-large;
        margin: 0;
        font-weight: 700;
        line-height: 2.5rem;
      }

      & > p {
        font-family: "Roboto";
        color: $color-text;
        font-size: $font-size-medium;
        line-height: 1.5rem;
        margin: 0.5rem 0;
      }
    }
  }

  @include desktop {
    section {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > img {
        aspect-ratio: 720 / 223;
        object-fit: cover;
      }

      & > .container {
        width: 43rem;
        box-sizing: border-box;

        & > h1 {
          font-size: $font-size-mega-large;
          line-height: 1.33;
        }

        & > p {
          font-size: $font-size-large;
          line-height: 2.25rem;
        }
      }
    }
  }
</style>
